import useSWRMutation from 'swr/mutation';
import fetcher from 'lib/fetcher';
import { toast } from 'react-toastify';

const useChangeFavoriteList = (id: number) => {
  async function fetchChangeFavoriteList(
    url: string,
    { arg }: { arg?: { title?: string; clientIds?: number[] } },
  ) {
    try {
      const data = await fetcher.patch(url, { ...arg });

      if (data?.error) {
        return toast.error(`Не удалось изменить список: ${data?.error}`, {
          autoClose: 5000,
        });
      }

      toast.success('Список изменен', { autoClose: 5000 });
      return data.result;
    } catch (error) {
      throw toast.error('Не удалось изменить список', { autoClose: 5000 });
    }
  }

  const { data, error, isMutating, ...rest } = useSWRMutation(
    `/favourites/list/${id}`,
    fetchChangeFavoriteList,
  );

  return { data, error, isMutating, ...rest };
};
export default useChangeFavoriteList;
